import React, { useState } from 'react';
import { TextField, InputAdornment, IconButton } from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';

export default function ApiKeySecretField({
  value,
  onChange,
  disabled = false,
  error = false,
  required = false,
}) {
  const [key_visible, setKeyVisible] = useState(false);

  const toggleKeyVisible = () => {
    setKeyVisible((prev) => !prev);
  };

  return (
    <TextField
      label='Key'
      type={key_visible ? 'text' : 'password'}
      value={value || ''}
      onChange={onChange}
      fullWidth
      disabled={disabled}
      error={error}
      required={required}
      autoComplete='new-password'
      InputProps={{
        endAdornment: (
          <InputAdornment position='end'>
            <IconButton
              aria-label={key_visible ? 'Hide key' : 'Show key'}
              onClick={toggleKeyVisible}
              edge='end'
              disabled={disabled}
              tabIndex={-1}
            >
              {key_visible ? <VisibilityOff /> : <Visibility />}
            </IconButton>
          </InputAdornment>
        ),
      }}
    />
  );
}
